import { Box } from "@mzc-pdc/ui";
import { Typography } from "@components_v2/typography/typography";
import theme from "@styles/theme";
import { useMemo } from "react";
import { alpha } from "@mui/material";

export const NotifyBadge = ({ domain }) => {
    const badgeConfig = useMemo(() => {
        switch (domain) {
            case "ASSET":
                return {
                    label: "Asset",
                    color: theme.palette.primary.main,
                };
            case "COLLECTION":
                return {
                    label: "Collection",
                    color: theme.palette.etc.purple600,
                };
            case "REQUEST":
                return {
                    label: "Request",
                    color: theme.palette.greySecondary[500],
                };
            case "CUSTOM_CONTENT":
                return {
                    label: "Custom Contents",
                    color: theme.palette.greySecondary["A400"],
                };
            case "PROJECT":
            default:
                return {
                    label: "Common",
                    color: theme.palette.success.main,
                };
        }
    }, [domain]);

    return (
        <Box
            sx={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: alpha(badgeConfig.color, 0.12),
                borderRadius: "9px",
                px: theme.spacing(1),
                minWidth: "60px",
                justifyContent: "center",
            }}
        >
            <Typography variant="body3_500" color={badgeConfig.color}>
                {badgeConfig.label}
            </Typography>
        </Box>
    );
};
